<div class="flex justify-between items-center flex-wrap gap-1 mb-1">
  <div class="flex gap-2 items-center flex-wrap">
  </div>
  <nz-page-header-extra>
    <nz-space>
      <nz-input-group class="mr-1" [nzPrefix]="searchIcon">
        <input
          nz-input
          class="w-full"
          type="search"
          [(ngModel)]="searchText"
          placeholder="Search here..."
          (ngModelChange)="getSearchDetails(searchText)"
          aria-label="Search sensors"
        />
      </nz-input-group>
      <ng-template #searchIcon>
        <span nz-icon nzType="search" aria-hidden="true"></span>
      </ng-template>
      <button
        nz-button
        class="mr-1"
        nzType="default"
        type="button"
        [nzTooltipColor]="'#fff'"
        nz-tooltip
        nzTooltipTitle="Refresh"
        [nzShape]="'circle'"
        (click)="refreshHandler()"
        aria-label="Refresh sensors"
      >
        <i nz-icon nzType="reload" aria-hidden="true"></i>
      </button>
      <button
        nz-button
        class="mr-1"
        [nzType]="'primary'"
        nzSize="default"
        (click)="isExcelModalVisible = true"
        aria-label="Add Excel"
      >
        <i nz-icon nzType="plus" aria-hidden="true"></i>Add Excel
      </button>
      <button
        nz-button
        class="mr-1"
        [nzType]="'primary'"
        nzSize="default"
        (click)="addEditAsset('add')"
        aria-label="Add Sensor"
      >
        <i nz-icon nzType="plus" aria-hidden="true"></i>Add Sensor
      </button>
      <button
        nz-button
        class="mr-1"
        [nzType]="'primary'"
        nzSize="default"
        (click)="isRequestExtSensorModalVisible = true"
        aria-label="Request External Sensor"
      >
        <i nz-icon nzType="plus" aria-hidden="true"></i>Request Ext Sensor
      </button>
    </nz-space>
  </nz-page-header-extra>
</div>

<nz-table
  #sensorTable
  nzShowSizeChanger
  [nzLoading]="this.apiCallLoaders['isSensorsLoading']"
  [nzScroll]="{ x: '1024px', y: '35dvh' }"
  [nzSize]="'small'"
  [nzPaginationType]="'small'"
  [nzShowTotal]="totalTemplate"
  [nzData]="filteredSensorList$"
  aria-label="Sensors table"
>
  <thead>
    <tr>
      @for (column of listOfColumns; track column) {
      <th nzEllipsis="..." scope="col">
        {{ column.name }}
      </th>
      }
      <th scope="col">ACTIONS</th>
    </tr>
  </thead>
  <tbody>
    <tr
      *ngFor="let sensor of sensorTable.data; let i = index; trackBy: commonService.trackByFn"
    >
      @for (column of listOfColumns; track column) {
      <td *ngIf="column.key === 'status'" nzEllipsis="...">
        <button
          nzType="default"
          class="text-[#fff] px-2 py-1 rounded-lg"
          [ngClass]="{
            'bg-[#008001]': sensor?.is_active,
            'bg-danger': !sensor?.is_active
          }"
        >
          <span
            *ngIf="sensor?.is_active"
            class="mr-1"
            style="font-size: 14px !important"
            nz-icon
            [nzType]="'hezky:Gateway'"
            aria-hidden="true"
          ></span>
          {{ sensor?.is_active ? 'Online' : 'Offline' }}
        </button>
      </td>

      <td *ngIf="column.key === 'sensor_name'" nzEllipsis="...">
        {{ sensor?.sensor_name || '-' }}
      </td>

      <td *ngIf="column.key === 'deviceeui'" nzEllipsis="...">
        {{ sensor?.deviceeui || '-' }}
      </td>

      <td *ngIf="column.key === 'model_number'" nzEllipsis="...">
        {{ sensor?.model_number || '-' }}
      </td>

      <td *ngIf="column.key === 'capabilities'">
        <ng-container *ngFor="let capability of sensor?.capabilities; index as i">
          <span
            class="mr-1"
            style="font-size: 18px !important;"
            [nzTooltipColor]="'#fff'"
            [nz-tooltip]="capability"
            nz-icon
            [nzType]="'hezky:' + capability"
            aria-hidden="true"
          ></span>
        </ng-container>
      </td>

      <td *ngIf="column.key === 'external_sensor'" nzEllipsis="...">
        {{ sensor?.external_sensor_serial_no || '-' }}
      </td>

      <td
        *ngIf="column.key === 'asset_name'"
        nzEllipsis="..."
        [ngClass]="!sensor?.asset_name ? 'text-success' : ''"
      >
        {{ sensor?.asset_name || 'Available' }}
      </td>

      <td *ngIf="column.key === 'display_name'" nzEllipsis="...">
        {{ sensor?.display_name || '-' }}
      </td>
      }

      <td nzEllipsis="...">
        <span
          nz-tooltip="Edit"
          [nzTooltipColor]="'#fff'"
          nz-icon
          nzType="edit"
          nzTheme="outline"
          class="text-base text-primary cursor-pointer"
          (click)="addEditAsset('edit', sensor)"
          aria-label="Edit sensor"
          role="button"
          tabindex="0"
        ></span>

        <span
          nz-tooltip="Delete"
          [nzTooltipColor]="'#fff'"
          nz-icon
          nzType="delete"
          nzTheme="outline"
          class="text-base text-danger cursor-pointer ml-5"
          nz-popconfirm
          nzPopconfirmPlacement="bottom"
          nzPopconfirmTitle="Are you sure to remove this record?"
          (nzOnConfirm)="deleteSensor(sensor.idt_sensor)"
          aria-label="Delete storage sensor"
          role="button"
          tabindex="0"
        ></span>
      </td>
    </tr>
  </tbody>
</nz-table>

<nz-modal
  [(nzVisible)]="isExcelModalVisible"
  [nzTitle]="modalTitle"
  (nzOnCancel)="handleCancel('excel')"
  [nzWidth]="550"
  aria-labelledby="excel-modal-title"
>
  <ng-template #modalTitle>
    <div class="flex justify-between items-center" id="excel-modal-title">
      <span class="text-lg font-medium">Add Excel</span>
      <a
        *ngIf="excelErrLink"
        (click)="downloadLogFile()"
        class="text-blue-600 font-bold cursor-pointer hover:underline"
        aria-label="Download log file"
      >
        <i
          nz-icon
          nzType="download"
          nzTheme="outline"
          class="mr-1"
          aria-hidden="true"
        ></i>
        Download Log
      </a>
    </div>
  </ng-template>

  <ng-template #excelContent>
    <ng-container>
      <div
        *ngIf="excelErr && !isSuccessMessage"
        class="mb-4 p-3 bg-red-50 text-red-700 border border-red-200 rounded-md"
        role="alert"
      >
        <strong>Error:</strong> {{ excelErr }}
      </div>

      <div
        *ngIf="excelErr && isSuccessMessage"
        class="mb-4 p-3 bg-green-50 text-green-700 border border-green-200 rounded-md"
        role="status"
      >
        <strong>Success:</strong> {{ excelErr }}
      </div>

      <div *ngIf="!excelErrLink" class="mb-3 text-center flex justify-end">
        <a
          class="cursor-pointer hover:underline text-blue-600 font-bold"
          nz-popconfirm
          (nzOnConfirm)="downloadTemplate()"
          nzPopconfirmTitle="Are you sure to download this template file?"
          nzPopconfirmPlacement="bottom"
        >
          <i
            nz-icon
            nzType="download"
            nzTheme="outline"
            class="mr-1"
          ></i>
          Download Template
        </a>
      </div>

      <div
        class="upload-container border-2 border-dashed border-gray-300 bg-white p-6 rounded-lg mb-4 text-center hover:border-blue-400 transition-colors"
      >
        <label for="excelFile" class="custom-file-upload w-full block cursor-pointer">
          <i
            nz-icon
            nzType="upload"
            nzTheme="outline"
            class="text-primary text-[32px] block mb-3"
            aria-hidden="true"
          ></i>
          <input
            type="file"
            id="excelFile"
            (change)="onFileChange($event)"
            accept=".xls,.xlsx,.csv"
            class="hidden"
          />
          <p class="ant-upload-text font-medium mb-2 text-base">
            Click or drag file to this area to upload
          </p>
          <p class="ant-upload-hint text-gray-500">
            File headers should match, and all fields must have appropriate data.
          </p>
        </label>
      </div>
      <div class="uploaded-files" *ngIf="fileList.length > 0" aria-live="polite">
        <h4 class="text-sm font-medium mb-3 text-gray-700 pl-1">Uploaded Files</h4>
        <div
          *ngFor="let file of fileList; let i = index"
          class="uploaded-file flex items-center justify-between p-3 mb-3 bg-white border border-gray-300 rounded-md hover:shadow-sm transition-shadow"
        >
          <div class="flex items-center">
            <i
              nz-icon
              [nzType]="
                file.name.toLowerCase().endsWith('.xlsx') ? 'file-excel' : 'file-excel'
              "
              nzTheme="twotone"
              class="mr-3 text-lg"
              aria-hidden="true"
            ></i>
            <span class="filename font-medium">{{ file?.name }}</span>
          </div>
          <div class="flex items-center gap-3">
            <span class="filesize text-sm text-gray-600">
              {{ (file.size / 1024 / 1024).toFixed(2) }} MB
            </span>
            <button
              type="button"
              nz-button
              nzType="text"
              nzDanger
              (click)="removeFile(i)"
              class="flex items-center justify-center p-1 hover:bg-red-50 rounded-full"
              aria-label="Remove file"
            >
              <i nz-icon nzType="delete" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #excelFooter>
    <div class="flex justify-end gap-3 pt-2">
      <button
        nz-button
        nzType="default"
        (click)="handleCancel('excel')"
        class="px-5 py-1 h-9"
        aria-label="Cancel"
      >
        Cancel
      </button>
      <button
        nz-button
        nzType="primary"
        (click)="onExcelSubmit()"
        [nzLoading]="isConfirmLoading"
        class="px-5 py-1 h-9"
        aria-label="Submit excel file"
      >
        Submit
      </button>
    </div>
  </ng-template>

  <ng-container *nzModalContent>
    <ng-container *ngTemplateOutlet="excelContent"></ng-container>
  </ng-container>

  <ng-container *nzModalFooter>
    <ng-container *ngTemplateOutlet="excelFooter"></ng-container>
  </ng-container>
</nz-modal>

<nz-modal
  [(nzVisible)]="isSensorModalVisible"
  [nzTitle]="isEditMode ? 'Edit Storage Sensor' : 'Add Storage Sensor'"
  (nzOnCancel)="handleCancel('sensor')"
  [nzWidth]="600"
  aria-labelledby="sensor-modal-title"
>
  <ng-template #sensorContent>
    <form
      nz-form
      [formGroup]="form"
      [nzLayout]="'vertical'"
      role="form"
      aria-labelledby="sensor-modal-title"
      class="p-4"
    >
      <div class="space-y-4">
        <nz-form-item>
          <nz-form-label
            [nzSpan]="24"
            nzRequired
            nzFor="sensor_name"
            class="pb-1 text-base"
            >Name</nz-form-label
          >
          <nz-form-control [nzSpan]="24" [nzErrorTip]="'Sensor Name is required'">
            <input
              nz-input
              formControlName="sensor_name"
              class="w-full py-2 px-3 rounded-md"
              maxlength="100"
              placeholder="Enter Sensor Name"
              id="sensor_name"
              aria-required="true"
            />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label
            [nzSpan]="24"
            nzRequired
            nzFor="modelNo"
            class="pb-1 text-base"
            >Model No.</nz-form-label
          >
          <nz-form-control
            [nzSpan]="24"
            [nzErrorTip]="'Sensor Model No is required'"
          >
            <nz-select
              formControlName="modelNo"
              (ngModelChange)="onModelNoChange($event)"
              nzPlaceHolder="Select Model No"
              class="w-full"
              nzShowSearch
              nzShowArrow="false"
              id="modelNo"
              aria-required="true"
            >
              <nz-option
                *ngFor="let model of modelNumbers"
                [nzValue]="model.model_no"
                [nzLabel]="model.model_no"
              >
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label
            [nzSpan]="24"
            nzRequired
            nzFor="deveui"
            class="pb-1 text-base"
            >Device EUI</nz-form-label
          >
          <nz-form-control [nzSpan]="24" [nzErrorTip]="'Device EUI is required'">
            <div class="relative">
              <input
                nz-input
                formControlName="deveui"
                class="w-full py-2 px-3 rounded-md"
                maxlength="20"
                placeholder="Enter or select Device EUI"
                (input)="onDeviceEUISearch($event)"
                id="deveui"
                aria-required="true"
              />
              <div
                *ngIf="filteredDeviceEUIs.length > 0"
                class="absolute z-10 w-full bg-white border border-gray-200 rounded-md shadow-md max-h-48 overflow-y-auto mt-1"
                role="listbox"
                aria-label="Device EUI options"
              >
                <ul class="py-1 m-0">
                  <li
                    *ngFor="let device of filteredDeviceEUIs"
                    class="px-4 py-2 hover:bg-blue-100 cursor-pointer"
                    (click)="selectDeviceEUI(device)"
                    role="option"
                    [attr.aria-label]="device.device_ui"
                  >
                    {{ device.device_ui }}
                  </li>
                </ul>
              </div>
            </div>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label
            [nzSpan]="24"
            class="pb-1 text-base"
            nzFor="capabilities"
            >Capabilities</nz-form-label
          >
          <nz-form-control [nzSpan]="24">
            <input
              nz-input
              formControlName="capabilities"
              class="w-full py-2 px-3 rounded-md bg-gray-50"
              maxlength="50"
              placeholder="Capabilities"
              [readonly]="true"
              id="capabilities"
            />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label
            [nzSpan]="24"
            class="pb-1 text-base"
            nzFor="extSensorId"
            >External Sensor ID</nz-form-label
          >
          <nz-form-control [nzSpan]="24">
            <div class="flex gap-2 items-end">
              <nz-select
                formControlName="extSensorId"
                nzPlaceHolder="Select External Sensor ID"
                class="flex-1"
                nzShowSearch
                nzShowArrow="false"
                id="extSensorId"
              >
                <nz-option
                  *ngFor="let sensor of unmappedExternalSensors"
                  [nzValue]="sensor.id"
                  [nzLabel]="sensor.external_sensor_sr_no"
                >
                </nz-option>
                <nz-option
                  *ngIf="unmappedExternalSensors.length === 0"
                  [nzValue]="null"
                  [nzLabel]="'No external sensors available'"
                  [nzDisabled]="true"
                >
                </nz-option>
              </nz-select>
              <button
                *ngIf="isEditMode && form.get('extSensorId')?.value"
                type="button"
                nz-button
                nzType="default"
                nzDanger
                nzSize="default"
                (click)="removeExternalSensor()"
                class="flex-shrink-0"
                aria-label="Remove external sensor"
              >
                <i nz-icon nzType="delete" aria-hidden="true"></i>
                Remove
              </button>
            </div>
          </nz-form-control>
        </nz-form-item>

        <div class="grid grid-cols-2 gap-4">
          <nz-form-item>
            <nz-form-label
              [nzSpan]="24"
              nzRequired
              nzFor="gatewayName"
              class="pb-1 text-base"
              >Gateway Name</nz-form-label
            >
            <nz-form-control
              [nzSpan]="24"
              [nzErrorTip]="'Gateway Name is required'"
            >
              <nz-select
                formControlName="gatewayName"
                nzPlaceHolder="Select Gateway"
                class="w-full"
                nzShowSearch
                nzShowArrow="false"
                id="gatewayName"
                aria-required="true"
              >
                <nz-option
                  *ngFor="let gateway of gatewaysByLocation"
                  [nzValue]="gateway.gateway_id"
                  [nzLabel]="gateway.gateway_name"
                >
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label
              [nzSpan]="24"
              nzRequired
              nzFor="location"
              class="pb-1 text-base"
              >Location</nz-form-label
            >
            <nz-form-control [nzSpan]="24">
              <nz-select
                nzMode="default"
                formControlName="location"
                nzPlaceHolder="Select Location"
                class="w-full"
                nzShowSearch
                nzShowArrow="false"
                id="location"
                aria-required="true"
              >
                <nz-option
                  *ngFor="let location of locationOptions"
                  [nzValue]="location.location_id"
                  [nzLabel]="location.display_name"
                >
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template #sensorFooter>
    <div class="flex justify-end gap-3 pt-2">
      <button
        nz-button
        nzType="default"
        (click)="handleCancel('sensor')"
        class="px-5 py-1 h-9"
        aria-label="Cancel"
      >
        Cancel
      </button>
      <button
        nz-button
        nzType="primary"
        (click)="onSubmit()"
        [nzLoading]="isConfirmLoading"
        class="px-5 py-1 h-9"
        [attr.aria-label]="isEditMode ? 'Update sensor' : 'Submit sensor'"
      >
        {{ isEditMode ? 'Update' : 'Submit' }}
      </button>
    </div>
  </ng-template>

  <ng-container *nzModalContent>
    <ng-container *ngTemplateOutlet="sensorContent"></ng-container>
  </ng-container>

  <ng-container *nzModalFooter>
    <ng-container *ngTemplateOutlet="sensorFooter"></ng-container>
  </ng-container>
</nz-modal>

<nz-modal
  [(nzVisible)]="isRequestExtSensorModalVisible"
  [nzTitle]="'Request External Sensor'"
  (nzOnCancel)="handleCancel('requestExtSensor')"
  [nzWidth]="600"
  aria-labelledby="requestExtSensor-modal-title"
>
  <ng-template #requestExtSensorContent>
    <form
      nz-form
      [formGroup]="requestExtSensorForm"
      [nzLayout]="'vertical'"
      role="form"
      aria-labelledby="requestExtSensor-modal-title"
      class="p-4"
    >
      <div class="grid grid-cols-2 gap-4">
        <nz-form-item>
          <nz-form-label
            [nzSpan]="24"
            nzRequired
            nzFor="location"
            class="pb-1 text-base"
            >Location</nz-form-label
          >
          <nz-form-control
            [nzSpan]="24"
            [nzErrorTip]="'Location is required'"
          >
            <nz-select
              formControlName="location"
              nzPlaceHolder="Select Location"
              class="w-full"
              nzShowSearch
              nzShowArrow="false"
              id="request_location"
              (ngModelChange)="onRequestLocationChange($event)"
            >
              <nz-option
                *ngFor="let location of locationOptions"
                [nzValue]="location.location_id"
                [nzLabel]="location.display_name"
              >
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label
            [nzSpan]="24"
            nzRequired
            nzFor="deviceeuis"
            class="pb-1 text-base"
            >Devices</nz-form-label
          >
          <nz-form-control
            [nzSpan]="24"
            [nzErrorTip]="'Select at least one device'"
          >
            <nz-select
              formControlName="deviceeuis"
              nzMode="multiple"
              nzPlaceHolder="Select Devices"
              class="w-full"
              nzShowSearch
              nzShowArrow="false"
              id="request_devices"
            >
              <nz-option
                *ngFor="let device of devicesForSelectedLocation"
                [nzValue]="device.deviceeui"
                [nzLabel]="device.sensor_name + ' (' + device.deviceeui + ')'"
              >
              </nz-option>
              <nz-option
                *ngIf="devicesForSelectedLocation.length === 0"
                [nzValue]="null"
                [nzLabel]="'No devices found for location'"
                [nzDisabled]="true"
              >
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </form>
  </ng-template>

  <ng-template #requestExtSensorFooter>
    <div class="flex justify-end gap-3 pt-2">
      <button
        nz-button
        nzType="default"
        (click)="handleCancel('requestExtSensor')"
        class="px-5 py-1 h-9"
        aria-label="Cancel"
      >
        Cancel
      </button>
      <button
        nz-button
        nzType="primary"
        (click)="onRequestExtSensorSubmit()"
        [nzLoading]="isConfirmLoading"
        class="px-5 py-1 h-9"
        aria-label="Submit request"
      >
        Submit
      </button>
    </div>
  </ng-template>

  <ng-container *nzModalContent>
    <ng-container *ngTemplateOutlet="requestExtSensorContent"></ng-container>
  </ng-container>

  <ng-container *nzModalFooter>
    <ng-container *ngTemplateOutlet="requestExtSensorFooter"></ng-container>
  </ng-container>
</nz-modal>

<ng-template #totalTemplate let-total>Showing {{ total }} items</ng-template>

